var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EMCoreTemplate',{attrs:{"category":"OSMLife","identity":"outstandingRequirementComment","entity":"osm_outstanding_req_cmt"}})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50c791fc","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Adm/EntityManagementLife/containers/OutstandingRequirementComment.vue
// module id = null
// module chunks = 